module.exports = {"id":"dp2_1l3q6","text":"Interacting Through Digital Technologies","instructions":"Why is refining prompts useful when using AI systems?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q6-a1","text":"Improves relevance of AI responses","score":3.7},{"id":"dp2_1l3q6-a2","text":"Removes need for user oversight","score":1.3},{"id":"dp2_1l3q6-a3","text":"Guarantees perfect system output","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q6.json
// module id = 997
// module chunks = 41